import React, { useCallback, useEffect, useMemo, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { apiRoute, ENUM_DASHBOARD_COLOR, ENUM_INTCAL_OPTION, funValidateNoInput, linksUrl, outTypeEnum, URIEncrypt } from "../../../constants/enum.js"
import { useFetchWithBody, usePost } from "../../../api/reactQueryCustomHooks.jsx"
import { calculateTotal, convertDate, exportOutStandingInterestReportToPDF, exportOutStandingReportToPDF, getDataSetByGroup } from "../../../Utility/utility.js"
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../../components/index.js"
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, FOOTER_TYPE, ROW_ACTION_BTN_TYPE } from "../../../components/NextUITable.jsx"
import { Input, CardBody, Card, Button, Spinner, Popover, PopoverTrigger, PopoverContent, Chip, useDisclosure, Select, SelectItem, Autocomplete, AutocompleteItem } from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowAltCircleRight, faArrowPointer, faCalculator, faCalendarDay, faCalendarDays, faDatabase, faDownload, faEdit, faRefresh } from "@fortawesome/free-solid-svg-icons"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { resetDetailParams, setIsRediOutstanding } from "../../../state/receiveEntrySlice.jsx"
import { toast } from "react-toastify"
import { isMobile } from "react-device-detect"

const OutRPartyDetail = () => {

  const { compCode, compName, endDate, isMultipleCompany } = useSelector((state) => state.company)
  const { currentParty, isFromDashboard } = useSelector(
    (state) => state.outstandingReceivable
  )

  const [data, setData] = useState([]);
  const [interestRate, setInterestRate] = useState(0);
  const { menu } = useSelector((state) => state.auth)
  const [selectedBalAmount, setSelectedBalAmount] = useState(0);
  const [selectedIntAmount, setSelectedIntAmount] = useState(0);
  const [interestDays, setInterestDays] = useState("");
  const [selectedKey, setSelectedKey] = useState([]);
  const [selBroker, setSelBroker] = useState({ key: "", value: "" });
  const [diffDueDate, setDiffDueDate] = useState(new Date())
  const [selCalIntOption, setSelCalIntOption] = useState(ENUM_INTCAL_OPTION.WithOutGst)
  const dispatch = useDispatch();
  const navigate = useNavigate()

  let userMenuComponent = useMemo(
    () =>
      menu?.userMenu?.map((item) => {
        if (item.controller !== null) return item.controller
        else return item.menuname
      }),
    [menu.userMenu]
  )

  const daysRange = useMemo(
    () =>
      currentParty.remaningDaysRange
        .replace(">", "")
        .replace("=", "")
        .split("<"),
    [currentParty.remaningDaysRange]
  )


  const { isPending, isError, data: partyDetail = [], mutate: filterData } = usePost({
    url: apiRoute.outstanding.partyDetail,
    queryKey: "OutstandingReceivablePartyDetail",

  })
  
  const funloadData = () => {
    filterData({
      data: {
        compcode: compCode.join(","),
        party_id: currentParty.id,
        showAge1: Number(daysRange[0]) ? Number(daysRange[0]) : 0,
        showAge2: Number(daysRange[1]) ? Number(daysRange[1]) : 99999,
        out_type: outTypeEnum.R,
        diff_duedate: new Date(diffDueDate).toISOString().split("T")[0]
      }
    })
    // setData(partyDetail)
  }
  useEffect(() => {
    dispatch(setIsRediOutstanding(false))
    funloadData()
  }, [])


  useEffect(() => {
    setData(partyDetail)
  }, [partyDetail])
  const {
    isLoading: isAddressPending,
    data: infoData = [],
  } = useFetchWithBody({
    url: apiRoute.outstanding.partyBrokerInfo,
    queryKey: "OutstandingPayablePartySummary-Address",
    inputData: {
      compcode: compCode.join(","),
      party_id: currentParty.id,
    }
  })

  const handleDiffDueDate = () => {
    funloadData();
    setSelectedBalAmount(0)
    setSelectedIntAmount(0)
    setInterestDays(0)
  }
  const handleResetDate = () => {
    setDiffDueDate(new Date())
    setSelectedBalAmount(0)
    setSelectedIntAmount(0)
    filterData({
      data: {
        compcode: compCode.join(","),
        party_id: currentParty.id,
        showAge1: Number(daysRange[0]) ? Number(daysRange[0]) : 0,
        showAge2: Number(daysRange[1]) ? Number(daysRange[1]) : 99999,
        out_type: outTypeEnum.R,
        diff_duedate: new Date().toISOString().split("T")[0]
      }
    })

  }

  const totalInvAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "inv_amount",
      }),
    [data]
  )
  const totalPayAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "pay_amount",
      }),
    [data]
  )
  const totalBalanceAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "balance_amount",
      }),
    [data]
  )
  const totalIntAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "int_amount",
      }),
    [data]
  )
  const totalTaxableAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "taxable_amount",
      }),
    [data]
  )

  let downloadDataFooter = {
    inv_date: "Total",
    inv_no: "",
    inv_amount: totalInvAmount,
    //taxable_amount: totalTaxableAmount,
    balance_amount: totalBalanceAmount,
    pay_amount: totalPayAmount,
    duedays: "",
    duedate: "",
    diff_days_inv_date: "",
    diff_days_due_date: "",
    //int_days: "",
    //int_amount: totalIntAmount,
    compname: "",
  }
  
  const exportColumns = [
    {
      uid: "inv_date",
      name: "Inv Date",
      type: COLUMN_TYPE.date,
    },
    {
      uid: "inv_no",
      name: "Inv No",
    },
    {
      uid: "inv_amount",
      name: "Inv Amt",
    },
    {
      uid: "pay_amount",
      name: "Rec Amt",
    },
    {
      uid: "balance_amount",
      name: "Balance Amt",
    },
    {
      name: "Due Days",
      uid: "duedays",
    },
    {
      name: "Due Date",
      uid: "duedate",
      type: COLUMN_TYPE.date,
    },
    {
      name: "Diff Days Inv.Dt",
      uid: "diff_days_inv_date",
    },
    {
      name: "Diff Days Due.Dt",
      uid: "diff_days_due_date",
    },

    {
      uid: "compname",
      name: "Company",
    },
  ]

  const handleClickPrev = () => {
  //  if (isFromDashboard)
    //  navigate(linksUrl.dashboard.tradingDashboard)
   // else
      navigate(linksUrl.outstanding.receivable.partyAgingSummary)
  }

  const fun_RemoveSelection = (selectedBill) => {
    let d = selectedKey.filter(x => selectedBill.indexOf(x) === -1)
    const currentDataIndex = data.findIndex((ele) => ele.transactionid == d[0]);
    if (currentDataIndex >= 0) {
      const updatedData = { ...data[currentDataIndex], int_amount: 0, int_days: data[currentDataIndex].diff_days_due_date };
      const newData = [...data];
      newData[currentDataIndex] = updatedData
      setData(newData)
    }
  }

  const isCalIntWithGst = () => {
    if (selCalIntOption == ENUM_INTCAL_OPTION.WithGst)
      return true
    else
      return false
  }

  const fun_CalBalnInterest = () => {

    let total_selectedBal = 0;
    let total_selectedInt = 0;
    let t_IntDays = "";

    if (selectedKey && selectedKey.length > 0) {
      let tempData;
      let intSrcColumn = ""
      if (isCalIntWithGst())
        intSrcColumn = "int_src_amount"
      else
        intSrcColumn = "taxable_amount"

      selectedKey.forEach(element => {
        let filterData = data.filter((args, i) => args.transactionid == element);

        if (filterData.length > 0) {
          total_selectedBal += filterData[0][intSrcColumn];
          setSelectedBalAmount(total_selectedBal.toFixed(2))

          t_IntDays = filterData[0].diff_days_due_date;

          if (interestDays && interestDays != "" && interestDays != "0")
            t_IntDays = interestDays

          let cal_Interest = 0
          if (interestRate > 0) {
            cal_Interest = (filterData[0][intSrcColumn] * interestRate) / 100 / 365 * t_IntDays // filterData[0].int_days //diff_days_due_date;
            total_selectedInt += cal_Interest
          }
          setSelectedIntAmount(total_selectedInt.toFixed(2))
          const currentItemIndex = data.findIndex((ele) => ele.transactionid == element);
          let newData;

          const updatedData = { ...data[currentItemIndex], int_amount: cal_Interest.toFixed(2), int_days: t_IntDays };
          if (tempData)
            newData = [...tempData]
          else
            newData = [...data];
          newData[currentItemIndex] = updatedData;
          setData(newData)
          tempData = newData;
        }
      });
    }
    else {
      setSelectedBalAmount(0)
      setSelectedIntAmount(0)
      setData(partyDetail)

    }

  }


  const fun_SetnterestDays = () => {

    if (selectedKey && selectedKey.length > 0) {
      let t_IntDays = ""

      let tempData;
      selectedKey.forEach(element => {

        let currentItemIndex = data.findIndex((args, i) => args.transactionid == element);

        let newData;
        if (interestDays && interestDays != null && interestDays != "" && interestDays != "0")
          t_IntDays = interestDays
        else
          t_IntDays = data[currentItemIndex].diff_days_due_date

        const updatedData = { ...data[currentItemIndex], int_days: t_IntDays };
        if (tempData)
          newData = [...tempData]
        else
          newData = [...data];
        newData[currentItemIndex] = updatedData;
        setData(newData)
        tempData = newData;

      });
    }
    if (!interestDays || interestDays == "" || interestDays == "0") {
      fun_CalBalnInterest()
    }

  }

  useEffect(() => {
    fun_SetnterestDays();
  }, [interestDays])


  const handleCheckSelection = useCallback((event) => {
    const { column, e } = event;

    if (e == "all") {
      let arrayAll = []
      data.forEach(ele => {
        arrayAll.push(ele.transactionid)
      });
      setSelectedKey(arrayAll)
    }
    else {
      let selectedBill = Array.from(e);
      let keyList = selectedBill.map(Number)
      if (selectedKey) {
        fun_RemoveSelection(keyList)
      }
      setSelectedKey(keyList);
    }
  }, [selectedKey])



  const INITIAL_VISIBLE_COLUMNS = [
    "inv_date",
    "inv_no",
    "inv_amount",
    "pay_amount",
    "balance_amount",
    "duedays",
    "duedate",
    "diff_days_inv_date",
    "diff_days_due_date",
    "compname",
  ]

  const columns = [
    {
      name: "INV DATE",
      uid: "inv_date",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "INV NO",
      uid: "inv_no",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "INV AMOUNT",
      uid: "inv_amount",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalInvAmount,
      },
    },
    {
      name: "Rec AMOUNT",
      uid: "pay_amount",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalPayAmount,
      },
    },

    {
      name: "BAL AMOUNT",
      uid: "balance_amount",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalBalanceAmount,
      },
    },

    {
      name: "Due Days",
      uid: "duedays",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "Due Date",
      uid: "duedate",
      type: COLUMN_TYPE.date,
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "Diff days/inv.Dt",
      uid: "diff_days_inv_date",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "Diff days/due.Dt",
      uid: "diff_days_due_date",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "COMPANY",
      align: COLUMN_ALIGN_TYPE.center,
      uid: "compname",
      sortable: true,
    },
  ]

  const onClickbtn = (item) => {
  }
  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
      onClick: onClickbtn,
      type: ROW_ACTION_BTN_TYPE.link,
    },

  ]
  const addReportDataFooter = (tempData) => {
    let downloadReportFooter = {}
    if (Object.keys(downloadReportFooter).length > 0) {
      return [...tempData, downloadReportFooter]
    }
    return tempData
  }

 
  let downloadReportFooter = {}

  const funCalReportTotal = (filterData) => {

    let totalInvAmount = 0;
    let totalPayAmount = 0;
    let totalBalanceAmount = 0;
    let totalTaxableAmount = 0;
    filterData.map((ele) => {
      totalPayAmount += ele.pay_amount;
      totalInvAmount += ele.inv_amount;
      totalBalanceAmount += ele.balance_amount;
    })

    downloadReportFooter = {
      inv_date: "Total",
      inv_no: "",
      inv_amount: totalInvAmount,
      pay_amount: totalPayAmount,
      balance_amount: totalBalanceAmount,
      duedays: "",
      duedate: "",
      diff_days_inv_date: "",
      diff_days_due_date: "",
      compname: "",
    }

    downloadDataFooter = {
      inv_date: "Total",
      inv_no: "",
      inv_amount: totalInvAmount,
      pay_amount: totalPayAmount,
      balance_amount: totalBalanceAmount,
      duedays: "",
      duedate: "",
      diff_days_inv_date: "",
      diff_days_due_date: "",
      compname: "",
    }
  }
  const keysToKeep = ['compname'];

  const handleEntry = () => {
    dispatch(resetDetailParams())
    dispatch(setIsRediOutstanding(true))
    navigate(linksUrl.receiveEntry.receive + "/" + URIEncrypt.Receive + linksUrl.receiveEntry.createReceiveEntry)
  }

  const partyBroker = useMemo(() => {
    let tempData = data
    if (selectedKey && selectedKey.length > 0) {
      tempData = data.filter(ele => selectedKey.includes(ele.transactionid));
    }
    const uniBroker = new Set(tempData.map(ele => ele.broker));
    return [...uniBroker].join(', ');
  }, [data, selectedKey])


  const handleOutSReport = () => {
    const groupKey = Object.keys(groupData);

    if (groupKey && groupKey.length > 0) {
      let newData = []
      let totalPayAmount = 0
      let totalInvAmount = 0
      let totalBalanceAmount = 0
      if (groupKey && groupKey.length > 0) {
        for (let i = 0; i < groupKey.length; i++) {
          totalPayAmount = 0
          totalInvAmount = 0
          totalBalanceAmount = 0
          groupData[groupKey[i]].map((ele) => {
            totalPayAmount += ele.pay_amount;
            totalInvAmount += ele.inv_amount;
            totalBalanceAmount += ele.balance_amount;
          })

          const footerData = {
            ...downloadDataFooter, inv_amount: totalInvAmount,
            balance_amount: totalBalanceAmount,
            pay_amount: totalPayAmount,
          }
          const tempData = {
            "broker": groupKey[i], "invoice": addReportDataFooter(groupData[groupKey[i]]),
            "footerData": isMultipleCompany ? footerData :
              Object.fromEntries(
                Object.entries(footerData).filter(([key, value]) => !keysToKeep.includes(key)))
          }
          //console.log(tempData)
          newData = [...newData, tempData]

        }
      }
      exportOutStandingReportToPDF({
        data: newData,
        downloadFileName: "Receivable_Outstanding_Report",
        reportTitle: `Receivable Outstanding ${endDate && endDate != "" ? "Up To " + convertDate(new Date(endDate).toISOString().split("T")[0]) : ""} For ${currentParty.name}`,
        downloadDataFooter: {},
        downloadBillDetail: {},
        exportColumns: isMultipleCompany ? exportColumns : exportColumns.filter((ele) => ele.uid != 'compname'),
        downloadFileheader: {
          "party": currentParty.name, "company": compName,
          "address": infoData && infoData.addData.length > 0 ? infoData.addData[0]?.Party_Address : "",
          "broker": "-"
          //selBroker && selBroker.key != "" && selBroker.key != null ?  selBroker.value : partyBroker ? partyBroker :
        },

      })
    }
    else {
      toast.error("No Data Found", {
        "position": "top-center"
      })
    }

  }

  const groupData = useMemo(() => {
    let fildata = data
    if (selectedKey && selectedKey.length > 0)
      fildata = data.filter(ele => selectedKey.includes(ele.transactionid));
    if (selBroker && selBroker.key != "" && selBroker.key != null) {
      if (selBroker.key == "0")
        fildata = fildata.filter(ele => ele.br_id == '');
      else
        fildata = fildata.filter(ele => ele.br_id == selBroker.key);
    }
    return getDataSetByGroup(fildata)

  }, [data, selectedKey, selBroker])


  const handleBrokerChange = (val) => {
    const filData = infoData.brokerData.filter(ele => ele.Party_Id == val)

    if (filData && filData.length > 0)
      setSelBroker({ key: val, value: filData[0].Party_Name })
    else
      setSelBroker({ key: val, value: "" })

  }


  if (isPending) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer
        pageName="Party Detail"
        info={[
          ["Party", currentParty.name],
          ["Aging", currentParty.remaningDaysRange],
        ]}
        breadcrumbs={["Receivable", "Party Detail"]}
        prevPage={{
          show: true,
          onClick: handleClickPrev,
        }}
      >
        {/* <Card shadow="sm" radius="sm" className="mb-3 h-full alert alert-info">
          <CardBody className="p-2">
            <div className="flex  items-center gap-2 w-full ">

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={"Due Date"}
                  views={["day", "month", "year"]}
                  format="DD/MM/YYYY"
                  value={
                    diffDueDate
                      ? dayjs(diffDueDate)
                      : diffDueDate
                  }
                  onChange={(newValue) => {
                    setDiffDueDate(dayjs(newValue).format("YYYY-MM-DD"))
                  }}
                  className={`${isMobile ? "max-w-28" : "max-w-36"}  font-semibold`}
                  slotProps={{ textField: { size: "small" } }}
                />
              </LocalizationProvider>

              <Button onPress={handleDiffDueDate} color="warning" size="sm" className={`${isMobile ? "w-auto" : ""}  text-sm`}
                startContent={<FontAwesomeIcon icon={faRefresh} />} >Refresh</Button>
              <Button onPress={handleResetDate} color="success" size="sm" className={`${isMobile ? "w-auto" : ""}  text-sm`}
                startContent={<FontAwesomeIcon icon={faCalendarDays} />} >Reset Date</Button>

            </div>
            

          </CardBody>
        </Card> */}


        <div className={`w-full flex  ${isMobile ? "flex-wrap" : ""}  ${userMenuComponent?.includes('ReceiveEntryMaster') ? "justify-between" : "justify-end"} text-right mb-2`}>
          {userMenuComponent?.includes('ReceiveEntryMaster') ?
            <div className={`${isMobile ? "order-1" : ""}`}>
              <Chip onClick={handleEntry} color="warning" radius="sm" size="sm" variant="shadow"
                className=" cursor-pointer" >
                <FontAwesomeIcon icon={faArrowAltCircleRight} className="mr-2" />Payment Receive Entry</Chip></div>

            : ''}
          <div className={`${isMobile ? "justify-between order-1 mt-2" : "justify-end "} gap-4 w-full flex items-center align-top `}>
            <Autocomplete
              className={`${isMobile ? "w-auto" : "max-w-xs"}  font-semibold`}
              size="sm"
              label="Broker"
              placeholder={""}
              //labelPlacement="outside"
              variant="flat"
              color="default"
              defaultItems={infoData && infoData?.brokerData ? infoData.brokerData : []}
              onSelectionChange={handleBrokerChange}
              selectedKey={selBroker.key}
            >
              {
                (item) => {

                  return (
                    <AutocompleteItem key={item.Party_Id}>{item.Party_Name}</AutocompleteItem>
                  )
                }
              }

            </Autocomplete>

            <Button onPress={handleOutSReport} color="primary" size="sm" className={`${isMobile ? "max-w-2xl" : "max-w-36"}  text-sm`}
              startContent={<FontAwesomeIcon icon={faDownload} />} >OutStanding</Button>
          </div>
        </div>
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          rowSelection={true}
          handleSelectionChange={handleCheckSelection}
          showAdvanceFilter={false}
          downloadFileName="Receivable_Outstanding_Detail"
          id="transactionid"
        />
      </MainContainer>
    </div>
  )
}

export default OutRPartyDetail
